import { render, staticRenderFns } from "./CreateInventoryTemplateComponent.vue?vue&type=template&id=89e3c0c4&scoped=true&"
import script from "./CreateInventoryTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./CreateInventoryTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e3c0c4",
  null
  
)

export default component.exports